const playSound = (sound, callback = () => {}, speed = 1) => {
  const snd = new Audio(sound);
  snd.playbackRate = speed;
  snd.play();
  snd.onended = callback
};

export default playSound